<template>
  <ViewTopics></ViewTopics>
</template>
<script>
import ViewTopics from "@/components/IAReputation/Views/Topics.vue"

export default {
  components: {ViewTopics},
}
</script>
